module.exports = __webpack_public_path__ + "img/case.8251fdfe.png";